export const projectData = [
  {
    id: "flight-price-prediction",
    title: "Flight Price Prediction System",
    category: "Machine Learning & Full Stack",
    description: "Developed a full-stack machine learning web application to predict flight ticket prices based on user travel details (airlines, stops, departure, duration) using a trained Scikit-learn regression model.",
    highlights: [
      "Trained Scikit-learn regression model with real-world aviation dataset",
      "Built responsive React frontend integrated with Flask REST API backend",
      "Automated CI/CD deployment on Vercel (Frontend) and Render (Backend)",
      "End-to-end data preprocessing, feature engineering, and model inference"
    ],
    tags: ["React", "Flask", "Python", "Scikit-learn", "Vercel", "Render", "REST API"],
    image: "/images/flight-prediction.png",
    link: "https://flight-price-prediction-project-xi.vercel.app/",
    github: "https://github.com/milanrouth43/Flight-Price-Prediction-Project",
    featured: true
  },
  {
    id: "sre-monitoring-observability",
    title: "SRE Monitoring & Observability Implementation",
    category: "Cloud & DevOps",
    description: "Designed and implemented an enterprise SRE monitoring and observability architecture using AWS CloudWatch, Prometheus, and Grafana. Configured dashboards, alerting rules, SLIs/SLOs, and incident workflow.",
    highlights: [
      "Deployed and validated end-to-end monitoring stack on Amazon EC2",
      "Created custom Grafana dashboards for metrics, CPU, latency, and throughput",
      "Engineered automated alerting rules, SLIs, and SLO definitions",
      "Documented complete production architecture with operational runbooks"
    ],
    tags: ["AWS", "Docker", "Prometheus", "Grafana", "Amazon CloudWatch", "EC2", "SRE"],
    image: "/images/sre-monitoring.png",
    link: "https://github.com/milanrouth43/SRE-Implementation",
    github: "https://github.com/milanrouth43/SRE-Implementation",
    featured: true
  },
  {
    id: "cloud-readiness-assessment",
    title: "Cloud Readiness & Migration Assessment",
    category: "Cloud & DevOps",
    description: "Conducted a comprehensive enterprise cloud readiness assessment and designed a phased 6-R migration strategy with cloud maturity scoring and TCO/ROI cost-benefit analysis for an e-commerce application.",
    highlights: [
      "Multi-dimensional cloud maturity scoring across security, ops, and architecture",
      "TCO (Total Cost of Ownership) & ROI estimation with AWS pricing models",
      "Phased wave-based migration roadmap ensuring zero business downtime",
      "Architected target AWS multi-tier cloud topology for scale & resilience"
    ],
    tags: ["Cloud Architecture", "AWS", "Migration Strategy", "TCO/ROI", "Enterprise Cloud"],
    image: "/images/cloud-migration.png",
    link: "https://github.com/milanrouth43",
    github: "https://github.com/milanrouth43",
    featured: true
  },
  {
    id: "productivity-dashboard",
    title: "Productivity Dashboard",
    category: "Web Applications",
    description: "Developed an interactive, all-in-one productivity suite integrating customizable task management, daily planning, Pomodoro focus timer, live weather updates, and motivational widgets.",
    highlights: [
      "Built interactive Pomodoro timer with auditory cues and customizable work/break intervals",
      "Implemented real-time date/time clock, persistent local storage, and weather widget",
      "Dynamic dark/light theme switching with smooth CSS transitions",
      "Fast, lightweight client-side architecture deployed on Vercel"
    ],
    tags: ["HTML5", "CSS3", "JavaScript", "Vercel", "LocalStorage", "Weather API"],
    image: "/images/productivity.png",
    link: "https://productivity-dashboard-ashen-nine.vercel.app/",
    github: "https://github.com/milanrouth43/Productivity-dashboard",
    featured: true
  },
  {
    id: "netflix-clone",
    title: "Netflix Clone",
    category: "Frontend & Web",
    description: "A high-fidelity, fully responsive clone of the Netflix streaming platform landing page built to master modern CSS layout techniques, media carousels, and responsive UI design.",
    highlights: [
      "Pixel-perfect responsive layout across mobile, tablet, and ultra-wide screens",
      "Interactive accordion FAQ section with smooth expand/collapse animations",
      "Custom hero video and backdrop banner overlays",
      "Fast, zero-dependency lightweight vanilla web architecture"
    ],
    tags: ["HTML5", "CSS3", "JavaScript", "Responsive Design", "Vercel"],
    image: "/images/netflix.png",
    link: "https://video-v.vercel.app/",
    github: "https://github.com/milanrouth43/video-v",
    featured: false
  },
  {
    id: "stone-paper-scissor",
    title: "Stone Paper Scissors Interactive Game",
    category: "Frontend & Web",
    description: "An engaging interactive browser game testing JavaScript DOM manipulation, event-driven architecture, game state persistence, and real-time score tracking.",
    highlights: [
      "Dynamic computer choice engine with pseudo-randomized probability",
      "Live score counters, streak trackers, and instant result feedback",
      "Fluid click animations and interactive tactile sound effects",
      "Deployed and accessible on Vercel with zero latency"
    ],
    tags: ["JavaScript", "Game Logic", "CSS3", "DOM Manipulation", "Vercel"],
    image: "/images/stone-paper.png",
    link: "https://stone-paper-scissor-beige-kappa.vercel.app",
    github: "https://github.com/milanrouth43/stone_paper_scissor",
    featured: false
  }
];
